const SplitUp = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="line_start_diamond">
      <mask
        id="mask0_1401_93210"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect
          id="Bounding box"
          y="18"
          width="18"
          height="18"
          transform="rotate(-90 0 18)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1401_93210)">
        <path
          id="line_start_diamond_2"
          d="M12.1313 11.25L9 8.11875L5.86875 11.25L9 14.3812L12.1313 11.25ZM14.25 11.25L9 16.5L3.75 11.25L8.25 6.75V1.5H9.75V6.75L14.25 11.25Z"
          fill="#36A5F0"
        />
      </g>
    </g>
  </svg>
);

export default SplitUp;
